<div class="product-list-container section-padding">
  <div class="container">
    <div class="header-section text-center">
      <h2 class="title">Our Fresh Baked Goods</h2>
      <p class="subtitle">Handcrafted daily with love and the finest ingredients.</p>
    </div>

    <div class="filter-bar text-center">
      <button 
        class="filter-btn" 
        [class.active]="selectedCategory === 'All'"
        (click)="selectCategory('All')">All</button>
      <button 
        *ngFor="let category of categories"
        class="filter-btn" 
        [class.active]="selectedCategory === category"
        (click)="selectCategory(category)">{{ category }}</button>
    </div>

    <div *ngIf="isLoading" class="loading-state text-center">
      <div class="spinner"></div>
      <p>Baking fresh items...</p>
    </div>

    <div *ngIf="!isLoading" class="product-grid-wrapper">
      @if (products.length === 0) {
        <div class="no-data-widget text-center">
          <p class="empty-message">No {{ selectedCategory !== 'All' ? selectedCategory.toLowerCase() : 'products' }} found. We're currently baking fresh items!</p>
        </div>
      } @else {
        <div class="product-grid">
          <a *ngFor="let product of products" [routerLink]="['/product', product.id]" class="product-card">
          <div class="image-wrapper">
            <img [src]="getImgSrc(product.imageUrl)" [alt]="product.name" class="product-image">
            <div *ngIf="product.isPopular" class="badge">Popular</div>
          </div>
          <div class="product-info">
            <div class="category-tag">{{ product.category }}</div>
            <h3 class="product-name">{{ product.name }}</h3>
            <p class="product-desc">{{ product.description }}</p>
          </div>
          </a>
        </div>
        @if (hasMore && products.length > 0) {
          <div #scrollSentinel class="scroll-sentinel" aria-hidden="true"></div>
        }
        @if (isLoadingMore) {
          <div class="loading-more text-center">
            <div class="spinner spinner-sm"></div>
          </div>
        }
      }
    </div>
  </div>
</div>
